module.exports = __webpack_public_path__ + "static/media/litis_logo.89e7d51d.jpg";